import { Observable } from 'rxjs';

export function fromMutationObserver(
  target: Node,
  options: MutationObserverInit
): Observable<MutationRecord[]> {
  return new Observable<MutationRecord[]>(subscriber => {
    const observer = new MutationObserver(mutations => {
      subscriber.next(mutations);
    });

    observer.observe(target, options);

    return () => observer.disconnect();
  });
}
